module.exports = __webpack_public_path__ + "img/bg.c0020717.svg";